import createClient from "openapi-fetch";
import type { paths } from "./types";

// Typed fetch client for the admin frontend (0016). Same shape as the
// user-app client: cookie-auth via credentials:"include", CSRF gate
// X-Requested-With:"xhr" on every request.
const baseUrl =
  import.meta.env.VITE_API_BASE_URL ??
  (typeof window !== "undefined" ? window.location.origin : "");

export const apiClient = createClient<paths>({
  baseUrl,
  credentials: "include",
  headers: {
    "X-Requested-With": "xhr",
  },
});
